/**
 * Remove Vietnamese diacritics from text for matching
 */
export function removeDiacritics(text: string): string {
  return text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D')
}

/**
 * Highlight search term in text (diacritic-insensitive)
 * Returns an array of parts with highlighted flag
 */
export function highlightText(
  text: string,
  searchTerm: string
): Array<{ text: string; highlighted: boolean }> {
  if (!searchTerm || !text) {
    return [{ text, highlighted: false }]
  }

  const normalizedText = removeDiacritics(text.toLowerCase())
  const normalizedSearch = removeDiacritics(searchTerm.toLowerCase().trim())

  if (!normalizedSearch) {
    return [{ text, highlighted: false }]
  }

  const parts: Array<{ text: string; highlighted: boolean }> = []
  let lastIndex = 0
  let searchIndex = normalizedText.indexOf(normalizedSearch)

  while (searchIndex !== -1) {
    // Add non-matching part before the match
    if (searchIndex > lastIndex) {
      parts.push({
        text: text.slice(lastIndex, searchIndex),
        highlighted: false,
      })
    }

    // Add the matching part (use original text with diacritics)
    parts.push({
      text: text.slice(searchIndex, searchIndex + normalizedSearch.length),
      highlighted: true,
    })

    lastIndex = searchIndex + normalizedSearch.length
    searchIndex = normalizedText.indexOf(normalizedSearch, lastIndex)
  }

  // Add remaining text after last match
  if (lastIndex < text.length) {
    parts.push({
      text: text.slice(lastIndex),
      highlighted: false,
    })
  }

  return parts.length > 0 ? parts : [{ text, highlighted: false }]
}
